import { NavLink } from "react-router-dom";
import styled from "styled-components";

export const HeaderStyled = styled.header`
  width: 100%;
  z-index: 10;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  transition: all var(--transition);
  background-color: var(--body-background);
  color: var(--color);
  background: transparent;

  &.scroll,
  &.burger-open {
    box-shadow: 0px 0px 8px 1px rgb(0 0 0 / 10%);
  }

  &.scroll:not(.burger-open) {
    background-color: var(--body-background-50);
    backdrop-filter: blur(10px);
  }

  .container {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 40px 30px;
    min-height: 100px;

    @media screen and (width < 768px) {
      padding: 0 20px;
      min-height: 60px;
    }

    & .header-nav {
      font-size: 16px;
      @media screen and (width < 1280px) {
        display: none;
      }

      & .active {
        color: var(--accent);
        pointer-events: none;
        text-shadow: 0 0 2px rgba(255, 255, 255, 0.25);
      }
    }
  }

  &.not-home-page {
    color: var(--color);
  }

  @media (max-width: 600px) {
    & .logo-img {
      width: 60px;
    }
  }
`;

export const BurgerButton = styled.button`
  background-color: transparent;
  border: none;
  outline: none;
  padding: 4px;
  width: 30px;
  height: 30px;
  display: flex;
  flex-direction: column;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 6px;

  & span {
    background: var(--body-background);
    border-radius: 10px;
    height: 2px;
    transition: 0.4s cubic-bezier(0.68, -0.6, 0.32, 1.6);

    &:nth-of-type(1) {
      width: 50%;
    }

    &:nth-of-type(2) {
      width: 100%;
    }

    &:nth-of-type(3) {
      width: 75%;
    }
  }

  &.is-open {
    & span {
      &:nth-of-type(1) {
        transform-origin: bottom;
        transform: rotatez(45deg) translate(4px, 1px);
      }

      &:nth-of-type(2) {
        transform-origin: top;
        transform: rotatez(-45deg);
      }

      &:nth-of-type(3) {
        transform-origin: bottom;
        width: 50%;
        transform: translate(9px, -5px) rotatez(45deg);
      }
    }
  }

  &.black {
    & span {
      background-color: #000;
    }
  }

  @media screen and (width >= 768px) {
    display: none;
  }
`;

export const Logo = styled.div`
  display: flex;
  font-weight: 700;
  color: var(--color);
  font-size: 18px;
  letter-spacing: 1px;
  gap: 5px;
  align-items: center;

  & svg {
    fill: currentColor;
  }

  & .logo-text {
    display: flex;
    flex-direction: column;
    gap: 2px;
  }

  .inc {
    font-size: 10px;
    font-weight: 400;
    letter-spacing: 2px;
    margin-left: 2px;
  }

  @media (max-width: 991px) {
    font-size: 18px;
    .inc {
      font-size: 10px;
    }
  }
  @media (max-width: 767px) {
    font-size: 16px;
    .inc {
      font-size: 9px;
    }
  }
`;

export const Nav = styled.nav`
  display: flex;
  align-items: center;
  gap: 36px;

  @media (max-width: 1199px) {
    gap: 24px;
  }
  @media (max-width: 991px) {
    gap: 16px;
    justify-content: flex-start;
    margin-top: 4px;
  }
  @media (max-width: 767px) {
    display: none;
  }
`;

export const NavLinkStyled = styled(NavLink)`
  color: var(--color);
  text-decoration: none;
  font-size: 18px;
  font-weight: 500;
  letter-spacing: 0.5px;
  text-align: center;

  &.active {
    color: var(--accent);
  }

  &:hover {
    text-decoration: underline;
  }

  @media (max-width: 991px) {
    font-size: 16px;
  }
  @media (max-width: 767px) {
    font-size: 15px;
  }
`;

export const Question = styled.span`
  color: var(--color);
  font-size: 17px;
  font-weight: 400;

  @media (max-width: 991px) {
    font-size: 15px;
  }
  @media (max-width: 767px) {
    display: none;
  }
`;

export const IconGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

export const IconButton = styled.a`
  background: var(--color);
  border-radius: 50%;
  border: none;
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;

  svg {
    display: block;
    fill: var(--body-background);
  }

  @media (max-width: 991px) {
    width: 32px;
    height: 32px;
    svg {
      width: 18px;
      height: 18px;
    }
  }
  @media (max-width: 767px) {
    width: 28px;
    height: 28px;
    svg {
      width: 15px;
      height: 15px;
    }
  }
`;

export const ServiceButton = styled.a`
  background: var(--accent);
  border-radius: 4rem;
  padding: 1rem 1.5rem;
  color: #fff;
  font-weight: 500;
  line-height: normal;
  transition: all 0.3s;
  margin-left: auto;

  &:hover {
    box-shadow: 0 0 2px 0 var(--accent);
  }

  @media (max-width: 1199px) {
    padding: 8px 24px;
    font-size: 16px;
    margin-left: 16px;
  }
  @media (max-width: 991px) {
    padding: 7px 18px;
    font-size: 15px;
    margin-left: 8px;
  }
  @media (max-width: 767px) {
    display: none;
  }
`;

export const LangSwitcher = styled.div`
  display: flex;
  align-items: center;
  gap: 15px;

  button {
    background-color: transparent;
    border: none;
    color: var(--color);
    font-size: 16px;
    cursor: pointer;
    opacity: 0.7;

    &.active {
      font-weight: 700;
      opacity: 1;
    }
  }

  @media (max-width: 1199px) {
    margin-left: 16px;
    button {
      font-size: 15px;
    }
  }
  @media (max-width: 991px) {
    margin-left: 8px;
    button {
      font-size: 14px;
    }
  }
`;

export const LeftContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 80px;

  @media (max-width: 991px) {
    gap: 25px;
  }
`;

export const RightContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 50px;

  @media (max-width: 991px) {
    gap: 25px;
  }
  @media (max-width: 767px) {
    display: none;
  }
`;
